__turbopack_context__.v({
  "toolButton": "styles-module__KUdbRG__toolButton",
});
